// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"d2aa61bb","321":"8b462c66","492":"0d9cfd0e","724":"fd123ef9","906":"c487eba8"}[chunkId] + ".chunk.css";
};